import React from 'react'
import CSSModules from "lib/utils/css-modules"
import styles from "./IntegrationLogDetails.less"

function formatJson(json) {
    let result = '';
    const indent = '  '; // Define the indentation string (2 spaces in this case)

    function processObject(obj, level) {
        const keys = Object.keys(obj);
        keys.forEach((key, index) => {
            const value = obj[key];
            const isLast = index === keys.length - 1;

            result += `${indent.repeat(level)}"${key}": `;

            if (typeof value === 'object' && value !== null) {
                result += '{\n';
                processObject(value, level + 1);
                result += `${indent.repeat(level)}}${isLast ? '' : ','}\n`;
            } else {
                const formattedValue = typeof value === 'string' ? `"${value}"` : value;
                result += `${formattedValue}${isLast ? '' : ','}\n`;
            }
        });
    }
    processObject(json, 0);
    return result;
}

@CSSModules(styles)
export default class IntegrationLogDetails extends React.PureComponent {
    render(){
        const { companyId, dateAdd, id, name, productId, source, taskUUID, json } = this.props
        return (
            <div styleName='integration-log-container'>
                <h2 styleName='integration-log-container-title'>{name}</h2>
                <div styleName='integration-log-info'>
                    <div >
                        <span styleName='integration-log-param-label'>ID:</span>
                        <span styleName='integration-log-param-value'>{id}</span>
                    </div>
                    <div >
                        <span styleName='integration-log-param-label'>Task UUID:</span>
                        <span styleName='integration-log-param-value'>{taskUUID}</span>
                    </div>
                    <div >
                        <span styleName='integration-log-param-label'>Date:</span>
                        <span styleName='integration-log-param-value'>{dateAdd}</span>
                    </div>
                    <div >
                        <span styleName='integration-log-param-label'>Product ID:</span>
                        <span styleName='integration-log-param-value'>{productId}</span>
                    </div>
                    <div >
                        <span styleName='integration-log-param-label'>Source ID:</span>
                        <span styleName='integration-log-param-value'>{source}</span>
                    </div>
                    <div >
                        <span styleName='integration-log-param-label'>Company ID:</span>
                        <span styleName='integration-log-param-value'>{companyId}</span>
                    </div>
                </div>
                <h2 styleName='integration-log-response-body-container'>Response body</h2>
                <div styleName='integration-log-response-body'>
                    {formatJson(json)}
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepIntegrations/IntegrationLogDetails.jsx